/* pg-acc-place */
(function(){
  if (window.pgAccPlace) return; window.pgAccPlace = 1;

  function place(){
    var root = document.getElementById('pgx');
    if (!root) return false;
    var gal = root.querySelector('.pgx-gallery');
    var acc = document.getElementById('pgx-desc');
    if (!gal || !acc) return false;

    /* Decoy first, so accLeft is disarmed before it can run again. */
    if (!gal.querySelector('[data-pg-accdecoy]')){
      var decoy = document.createElement('div');
      decoy.className = 'pgx-acc';
      decoy.setAttribute('data-pg-accdecoy', '1');
      decoy.setAttribute('aria-hidden', 'true');
      decoy.style.setProperty('display', 'none', 'important');
      gal.insertBefore(decoy, gal.firstChild);
    }

    /* Put the real one back if it was already moved. */
    var buy = root.querySelector('.pgx-buy');
    if (buy && acc.parentElement !== buy){
      /* 2026-09-23: returns removed site-wide by owner request; the guarantee bar is gone, so the payment icons are the anchor */
      var guar = buy.querySelector('.pgx-guar') || buy.querySelector('.pgx-pay');
      if (guar) guar.insertAdjacentElement('afterend', acc);
      else buy.appendChild(acc);
      acc.style.removeProperty('margin-top');
    }
    return true;
  }

  function boot(){
    if (place()) return;
    /* pg-landing renders server-side, so this normally lands first try; the
       retries only cover a slow parse. */
    var n = 0;
    var t = setInterval(function(){ if (place() || ++n > 20) clearInterval(t); }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
